// extracted by mini-css-extract-plugin
export default {"paragrafo":"ModalPedido_paragrafo__ab5Ct"};